import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Clock } from 'lucide-react';
interface ComingSoonProps {
  title: string;
}
export const ComingSoon: React.FC<ComingSoonProps> = ({
  title
}) => {
  const navigate = useNavigate();
  return <div className="w-full" data-id="element-105">
      <div className="p-6 border-b" data-id="element-106">
        <div className="max-w-6xl mx-auto" data-id="element-107">
          <button onClick={() => navigate('/')} className="flex items-center text-primary" data-id="element-108">
            <ArrowLeft className="h-4 w-4 mr-2" data-id="element-109" />
            Back to Users
          </button>
        </div>
      </div>
      <div className="max-w-6xl mx-auto p-6" data-id="element-110">
        <div className="text-center py-20" data-id="element-111">
          <div className="flex justify-center mb-6" data-id="element-112">
            <div className="h-20 w-20 rounded-full bg-muted/50 flex items-center justify-center" data-id="element-113">
              <Clock className="h-10 w-10 text-muted-foreground" data-id="element-114" />
            </div>
          </div>
          <h1 className="text-3xl font-bold mb-4" data-id="element-115">{title} Coming Soon</h1>
          <p className="text-muted-foreground max-w-md mx-auto mb-8" data-id="element-116">
            We're working hard to bring you this feature. Please check back
            later for updates.
          </p>
          <button onClick={() => navigate('/')} className="inline-flex items-center justify-center px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90 transition-colors" data-id="element-117">
            Return to Users
          </button>
        </div>
      </div>
    </div>;
};